var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-social-links"},[_c('ul',_vm._l((_vm.links),function(link){return _c('li',[_c('a',{class:'icon-'+link.icon,attrs:{"href":link.url,"target":"_blank","data-gtm":"Social Links > Click","data-gtm-value":link.icon}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5b5f9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/SocialLinks.vue
// module id = GSio
// module chunks = 0